/**
 * Ajout de boutons radio pour les variations produit
 */
export function initCheckboxVariations(target,product_id){
  if($(target).find('table.variations select').length>0){
    $(target).find('.woocommerce-variation,table.variations').addClass('d-none');
    $(target).find('table.variations').parent().prepend('<div class="variations_radios mb-3"></div>');

    var json = JSON.parse($(target).find('form.variations_form').attr('data-product_variations'));

    Object.keys(json).forEach(function(prop){
        var label = $.map(json[prop].attributes, function(v){return v;}).join(', ');
        var names = $.map(json[prop].attributes, function(v){return v;}).join('|');

        console.log(json[prop].attributes);
        
        var desc = '';
        if(json[prop].variation_description){desc = json[prop].variation_description.replace(/(<([^>]+)>)/gi, "");}

        var availability = '';
        if(json[prop].availability_html){availability = ' <em class="text-danger">('+json[prop].availability_html.replace(/(<([^>]+)>)/gi, "").trim()+')</em>';}

        label += availability;

        var price = '';
        if(json[prop].price_html){price = json[prop].price_html;}

        $(target).find('.variations_radios').append('<div class="variations_radios_item"><input type="radio" data-attrs="' + btoa(JSON.stringify(json[prop].attributes)) + '" data-names="' + btoa(names) + '" name="variations_radios" id="variations_radios_'+product_id+'_'+prop+'" value="" class="variations_radios_input form-check-input me-3"> <label class="variations_radios_label d-flex align-items-center flex-grow-1" for="variations_radios_'+product_id+'_'+prop+'"><span class="variations_radios_desc"><strong>' + label + '</strong><br>'+desc+'</span><span class="variations_radios_price ms-auto">'+price+'</span></label></div>');
    });

    var selected = [];
    $(target).find('table.variations select').each(function(){
      selected.push($(this).val());
    });
    $(target).find('.variations_radios input[data-names="'+btoa(selected.join('|'))+'"]').attr('checked',true).parent().addClass('active');

    $(target).find('.variations_radios .variations_radios_input').on('click', function () {
      if($(this).parent().hasClass('active')){
        $(this).prop('checked',false);
        $(target).find('.variations_radios_item').removeClass('active');
        $(target).find('table.variations select').val('').trigger('change');
      }else{
        $(target).find('.variations_radios_item').removeClass('active');
        $(this).parent().addClass('active');
        var json_item = JSON.parse(atob($(this).attr('data-attrs')));
        $(target).find('table.variations select').val('').trigger('change');
        Object.keys(json_item).forEach(function(prop_item){
          var val = json_item[prop_item];
          $(target).find('select[name='+prop_item+']').val(val).trigger('change');
        });
      }
    });

    $(target).find('.variations_radios .variations_radios_input').first().trigger('click');
  }
}